import {Component, inject, Renderer2} from '@angular/core';
import {
  ApplicationAlertService,
  AppRoot,
  LocalLanguageService,
  PersistenceService,
  SettingsService,
  UiUpdateService,
  ValidationChangeService,
  ModelChangeService,
  LogManager,
  BasicVsciModule,
} from '@visana-web/basic-ui';
import {ActivatedRoute, Router, NavigationEnd, Event} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {ClientModel} from 'app/model/client-model';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {Meta, Title} from '@angular/platform-browser';
import {SearchCriteriaComponent} from "./component/search-criteria/search-criteria.component";
import {SearchResultComponent} from "./component/search-result/search-result.component";
import {NgClass, AsyncPipe} from "@angular/common";
import {FooterLink} from '@visana-web/basic-ui/lib/basic-vsci/pwr/layout/footer/footer.types';
import {map, Observable} from 'rxjs';


@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [
    BasicVsciModule,
    TranslateModule,
    SearchCriteriaComponent,
    SearchResultComponent,
    NgClass,
    AsyncPipe
  ]
})
export class AppComponent extends AppRoot {

  spinner = false;

  clientModel = new ClientModel();

  public footerLinks$: Observable<FooterLink[]> = this.initFooterLinks();

  private gtmService = inject(GoogleTagManagerService);

  constructor(protected translateService: TranslateService,
              protected localLanguageService: LocalLanguageService,
              protected route: ActivatedRoute,
              protected router: Router,
              protected applicationAlertService: ApplicationAlertService,
              protected validationChangeService: ValidationChangeService,
              protected uiUpdateService: UiUpdateService,
              protected persistenceService: PersistenceService,
              protected settingsService: SettingsService,
              protected renderer: Renderer2,
              private modelChangeService: ModelChangeService<ClientModel>,
              protected logManager: LogManager,
              protected titleService: Title,
              protected metaTagService: Meta,
  ) {
    super(translateService,
      localLanguageService,
      route,
      router,
      applicationAlertService,
      validationChangeService,
      uiUpdateService,
      persistenceService,
      settingsService,
      logManager,
      titleService,
      metaTagService,
      renderer);
    this.currentAppName = 'Visana';
    this.currentPageMetaTitle = 'pkb.imprestAccount.app-title';
    this.currentPageMetaDescription = 'pkb.imprestAccount.search-title';
    this.handledQueryParams = ['_ga', 'reset'];
    this.modelChangeService.updateModel(this.clientModel);
    this.modelChangeService.observableModel.subscribe(value => {
      this.clientModel = value;
    });
    this.router.events.subscribe((value:Event) => {
      if (value instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: value.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  private initFooterLinks() {
		return this.translateService
			.stream([
				'basic.footer_imprint',
				'basic.footer_imprintUrl',
				'basic.footer_privacy',
				'basic.footer_privacyUrl',
				'basic.footer_legalNotice',
				'basic.footer_legalNoticeUrl',
			])
			.pipe(
				map((t) => [
					{
						href: t['basic.footer_imprintUrl'],
						text: t['basic.footer_imprint'],
					},
					{
						href: t['basic.footer_privacyUrl'],
						text: t['basic.footer_privacy'],
					},
					{
						href: t['basic.footer_legalNoticeUrl'],
						text: t['basic.footer_legalNotice'],
					},
				]),
			);
	}

  public changeLang(lang: string) {
    const language = lang?.toLowerCase() || 'de';
    this.localLanguageService.setLocalLang(language);
    this.translateService.use(language);
    this.translateService.currentLang;
  }

  public handleHttpResponse(resp: HttpErrorResponse | HttpResponse<any>): boolean {
    if (super.handleHttpResponse(resp)) {
      return true;
    }
    // suppress entity too large error message toaster for typeahead component
    if ((resp.status === 413) && (resp.url?.includes('cityMappings'))) {
      return true;
    }

    if ((resp.status === 413) && (resp.url?.includes('gatekeepers/search'))) {
      return true;
    }
    return false;
  }
}
